"use strict";
/*
 * Created on 09.05.2019
 */

var _toConsumableArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var PromoSettingsValidatorSets_1 = require("../PromoSettingsValidatorSets");
/**
 * Changed workflow state settings model
 * @author Tomáš Leity
 *
 * @param overallThresholdsActivated
 * @param salesRelTh
 * @param salesAbsTh
 * @param impactBM2RelTh
 * @param impactBM2AbsTh
 * @param productThresholdsActivated
 * @param promoVolumeRelTh
 * @param promoVolumeAbsTh
 * @param promoPriceRelTh
 * @param promoPriceAbsTh
 * @param promoPurchasePriceRelTh
 * @param promoPurchasePriceAbsTh
 * @param unitBackDiscountRelTh
 * @param unitBackDiscountAbsTh
 */


var ChangedWorkflowStateSettings =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ChangedWorkflowStateSettings, _DomainObject_1$Domai);

  function ChangedWorkflowStateSettings(overallThresholdsActivated, salesRelTh, salesAbsTh, impactBM2RelTh, impactBM2AbsTh, productThresholdsActivated, promoVolumeRelTh, promoVolumeAbsTh, promoPriceRelTh, promoPriceAbsTh, promoPurchasePriceRelTh, promoPurchasePriceAbsTh, unitBackDiscountRelTh, unitBackDiscountAbsTh) {
    var _this;

    _classCallCheck(this, ChangedWorkflowStateSettings);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ChangedWorkflowStateSettings).call(this));
    _this.overallThresholdsActivated = overallThresholdsActivated;
    _this.salesRelTh = salesRelTh;
    _this.salesAbsTh = salesAbsTh;
    _this.impactBM2RelTh = impactBM2RelTh;
    _this.impactBM2AbsTh = impactBM2AbsTh;
    _this.productThresholdsActivated = productThresholdsActivated;
    _this.promoVolumeRelTh = promoVolumeRelTh;
    _this.promoVolumeAbsTh = promoVolumeAbsTh;
    _this.promoPriceRelTh = promoPriceRelTh;
    _this.promoPriceAbsTh = promoPriceAbsTh;
    _this.promoPurchasePriceRelTh = promoPurchasePriceRelTh;
    _this.promoPurchasePriceAbsTh = promoPurchasePriceAbsTh;
    _this.unitBackDiscountRelTh = unitBackDiscountRelTh;
    _this.unitBackDiscountAbsTh = unitBackDiscountAbsTh;
    return _this;
  }

  return ChangedWorkflowStateSettings;
}(DomainObject_1.DomainObject);

exports.ChangedWorkflowStateSettings = ChangedWorkflowStateSettings;

ChangedWorkflowStateSettings.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ChangedWorkflowStateSettings.name);
  return {
    overallThresholdsActivated: builder.bool('overallThresholdsActivated'),
    salesRelTh: builder.num.apply(builder, ['salesRelTh'].concat(_toConsumableArray(PromoSettingsValidatorSets_1.PromoSettingsValidatorSets.getNumberValidators))),
    salesAbsTh: builder.num.apply(builder, ['salesAbsTh'].concat(_toConsumableArray(PromoSettingsValidatorSets_1.PromoSettingsValidatorSets.getNumberValidators))),
    impactBM2RelTh: builder.num.apply(builder, ['impactBM2RelTh'].concat(_toConsumableArray(PromoSettingsValidatorSets_1.PromoSettingsValidatorSets.getNumberValidators))),
    impactBM2AbsTh: builder.num.apply(builder, ['impactBM2AbsTh'].concat(_toConsumableArray(PromoSettingsValidatorSets_1.PromoSettingsValidatorSets.getNumberValidators))),
    productThresholdsActivated: builder.bool('productThresholdsActivated'),
    promoVolumeRelTh: builder.num.apply(builder, ['promoVolumeRelTh'].concat(_toConsumableArray(PromoSettingsValidatorSets_1.PromoSettingsValidatorSets.getNumberValidators))),
    promoVolumeAbsTh: builder.num.apply(builder, ['promoVolumeAbsTh'].concat(_toConsumableArray(PromoSettingsValidatorSets_1.PromoSettingsValidatorSets.getNumberValidators))),
    promoPriceRelTh: builder.num.apply(builder, ['promoPriceRelTh'].concat(_toConsumableArray(PromoSettingsValidatorSets_1.PromoSettingsValidatorSets.getNumberValidators))),
    promoPriceAbsTh: builder.num.apply(builder, ['promoPriceAbsTh'].concat(_toConsumableArray(PromoSettingsValidatorSets_1.PromoSettingsValidatorSets.getNumberValidators))),
    promoPurchasePriceRelTh: builder.num.apply(builder, ['promoPurchasePriceRelTh'].concat(_toConsumableArray(PromoSettingsValidatorSets_1.PromoSettingsValidatorSets.getNumberValidators))),
    promoPurchasePriceAbsTh: builder.num.apply(builder, ['promoPurchasePriceAbsTh'].concat(_toConsumableArray(PromoSettingsValidatorSets_1.PromoSettingsValidatorSets.getNumberValidators))),
    unitBackDiscountRelTh: builder.num.apply(builder, ['unitBackDiscountRelTh'].concat(_toConsumableArray(PromoSettingsValidatorSets_1.PromoSettingsValidatorSets.getNumberValidators))),
    unitBackDiscountAbsTh: builder.num.apply(builder, ['unitBackDiscountAbsTh'].concat(_toConsumableArray(PromoSettingsValidatorSets_1.PromoSettingsValidatorSets.getNumberValidators)))
  };
}();